import { StorageService } from '../../commons/services/storageService.service';
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { EmSidebarTarget } from '@everymundo/em-cms-kit/emSidebar';
import getEnvironmentSettings from "../../commons/configs/env-conf-loader";

@Component({
    selector: "op-environment-warning",
    templateUrl: "./opEnvironmentWarning.view.html",
    styleUrl: "./opEnvironmentWarning.style.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EmSidebarTarget]
})
export class OpEnvironmentWarning {

  private readonly _storage = inject(StorageService);
  protected readonly showWarning = signal(true);

  constructor() {
    const active = this._storage.session.get.prodWarning();
    const env = getEnvironmentSettings();
    this.showWarning.set((env.name == "Production" && (active == null || active)) ? true : false);
  }

  understand() {
    this._storage.session.set.prodWarning(false);
    this.showWarning.set(false);
  }
}
